<template>
  <div class="container event__content-container">
    <EventInfo class="event__content-card" :event-id="eventId" />
    <EventCalendar class="event__content-card" id="event-calendar" />
    <EventCompanyProfile
      id="event-company-profile"
      class="event__content-card"
    />

    <EventUsers id="event-users" class="event__content-card" />
    <EventCatalogPlacement
      id="event-catalog-placement"
      class="event__content-card catalog"
    />
  </div>
</template>
<script>
import EventInfo from "@/components/Custom/EventInfo.vue";
import { mapGetters } from "vuex";
import EventCompanyProfile from "@/components/Custom/EventCompanyProfile.vue";
import EventCatalogPlacement from "@/components/Custom/EventCatalogPlacement.vue";
import EventUsers from "@/components/Custom/EventUsers.vue";
import EventCalendar from "@/components/Custom/EventCalendar.vue";

export default {
  name: "ParticipantPartTime",

  components: {
    EventCalendar,
    EventUsers,
    EventCatalogPlacement,
    EventCompanyProfile,
    EventInfo
  },
  computed: {
    ...mapGetters("event", ["eventId", "isServiceShown"])
  }
};
</script>
